/*
 * Logo component
 * This component is used to display the Dragonfly logo
 */
export const Logo = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 16C16 16 16.7442 15.4903 16.9712 15.3687C17.176 15.259 17.3572 15.1433 17.5114 15.0879C19.7334 14.2891 21.0121 14.3469 21.8563 14.383C23.2367 14.3521 24.2562 14.3588 25.5935 13.4747C26.0854 13.1494 26.452 12.674 26.6969 12.1634C27.613 10.2521 27.2778 7.89129 25.6921 6.30671C24.1052 4.72122 21.7406 4.38697 19.8271 5.30441C19.3174 5.54886 18.8703 5.92955 18.5182 6.40524C17.5734 7.68161 17.5728 8.69018 17.6091 10.1394C17.5737 10.9166 17.7089 12.2656 16.9077 14.4847C16.8516 14.6402 16.7377 14.8167 16.6258 15.0235C16.5042 15.2481 16 16 16 16Z"
        fill="#F2318A"
      />
      <path
        d="M15.9998 16C15.9998 16 15.2556 16.5098 15.0286 16.6314C14.8237 16.7411 14.6426 16.8568 14.4884 16.9122C12.2664 17.711 10.9877 17.6532 10.1435 17.6171C8.76311 17.648 7.74357 17.6413 6.40634 18.5254C5.91444 18.8507 5.54773 19.3261 5.30295 19.8367C4.38678 21.748 4.72184 24.1088 6.30773 25.6933C7.89456 27.2789 10.2592 27.6131 12.1727 26.6955C12.6824 26.4513 13.1295 26.0705 13.4816 25.5948C14.4263 24.3185 14.427 23.3099 14.3907 21.8607C14.4261 21.0834 14.2909 19.7345 15.0921 17.5153C15.1482 17.3599 15.2621 17.1834 15.374 16.9766C15.4956 16.752 15.9998 16 15.9998 16Z"
        fill="#F2318A"
      />
      <path
        d="M17.6402 25.5598C19.8272 27.7467 23.3729 27.7467 25.5598 25.5598C27.7467 23.3728 27.7467 19.8271 25.5598 17.6402C23.3729 15.4533 19.8272 15.4533 17.6402 17.6402C15.4533 19.8271 15.4533 23.3728 17.6402 25.5598Z"
        fill="#19D3C8"
      />
      <path
        d="M6.44001 14.3598C8.62695 16.5468 12.1727 16.5468 14.3596 14.3598C16.5465 12.1729 16.5465 8.62718 14.3596 6.44025C12.1727 4.25331 8.62695 4.25331 6.44001 6.44025C4.25307 8.62718 4.25307 12.1729 6.44001 14.3598Z"
        fill="#19D3C8"
      />
    </svg>
  );
};
